module.exports = __webpack_public_path__ + "static/media/hubspot-logo.5de1c7c0.svg";